import Keycloak from "keycloak-js";

const keycloak = new Keycloak({

  url: "https://authdev.tonichub.io/auth/",
  realm: "TonicX",
  clientId: "tonicx-react-client",
  redirectUri: "http://localhost:3000/",

});

export default keycloak;
